module.exports = __webpack_public_path__ + "img/twitter-brands.1a50ad78.svg";